export default "__VITE_ASSET__ca6ae630__"